import globalLanguages from '../../../locales/global-languages.json';

function SELandingCtrl(
    $scope,
    AuthService,
    $mdMedia,
    $mdDialog,
    $state,
    WriterAssistantService,
    UserService,
    $timeout,
    $interval,
    $translate
) {
    const vm = $scope;

    vm.$mdMedia = $mdMedia;
    vm.langs = globalLanguages;
    window.onbeforeunload = null;

    vm.articles = [];
    vm.filteredArticles = [];
    vm.articleSearch = '';
    vm.articleFilter = 'all';
    vm.articleViewMode = 'widget';
    vm.articleViewOptions = [
        {value: 'widget', label: 'wa.landing.library.view.widget', icon: 'ti ti-layout-grid'},
        {value: 'list', label: 'wa.landing.library.view.list', icon: 'ti ti-list'}
    ];
    vm.articleCounts = {
        all: 0,
        ai: 0,
        manual: 0,
    };
    vm.isLoading = true;
    vm.workflowStep = 0;
    vm.writingPreview = {
        title: '',
        paragraph1: '',
        heading: '',
        paragraph2: '',
        heading2: '',
        paragraph3: '',
        showCover: false,
        showImages: false,
    };
    vm.writingBlock = -1;
    vm.writingScore = 24;
    vm.writingReasoning = '';
    vm.writingSuggestions = createWritingSuggestions();
    vm.rankingVisits = '0';
    vm.rankingPosition = '#10';
    vm.analysisLimit = {};
    vm.aiCreditsLimit = {};

    vm.articleDataSet = {
        id: null,
        mode: 'WRITE_WITH_AI',
        mainKeyword: '',
        country: 'IT',
        language: 'it',
        device: 'mobile',
    };

    vm.createArticle = createArticle;
    vm.deleteArticle = deleteArticle;
    vm.applyArticleFilters = applyArticleFilters;
    vm.setArticleFilter = setArticleFilter;
    vm.setArticleViewMode = setArticleViewMode;
    vm.setCreationMode = setCreationMode;
    vm.isCreationMode = isCreationMode;
    vm.clearArticleFilters = clearArticleFilters;
    vm.hasActiveFilters = hasActiveFilters;
    vm.focusComposer = focusComposer;
    vm.setWorkflowStep = setWorkflowStep;
    vm.pauseWorkflow = pauseWorkflow;
    vm.resumeWorkflow = resumeWorkflow;

    let workflowTimer = null;
    let writingTimer = null;
    let rankingTimer = null;
    let rankingProgress = 0;
    let writingSegments = [];
    let writingSegmentIndex = 0;
    let writingTypedCharacters = 0;
    let writingTotalCharacters = 0;
    let writingComplete = false;
    let lastWritingScrollAt = 0;

    getArticles();
    hydrateCachedLimits();
    updateLimits();
    resumeWorkflow();

    function advanceWorkflow() {
        activateWorkflowStep((vm.workflowStep + 1) % 4);
    }

    function pauseWorkflow() {
        if (workflowTimer) {
            $timeout.cancel(workflowTimer);
            workflowTimer = null;
        }
        if (writingTimer) {
            $interval.cancel(writingTimer);
            writingTimer = null;
        }
        if (rankingTimer) {
            $interval.cancel(rankingTimer);
            rankingTimer = null;
        }
    }

    function resumeWorkflow() {
        if (workflowTimer) {
            return;
        }
        if (prefersReducedMotion()) {
            return;
        }
        if (vm.workflowStep === 2) {
            startWritingAnimation(false);
        } else if (vm.workflowStep === 3) {
            startRankingAnimation(false);
        }
        scheduleWorkflowAdvance();
    }

    function scheduleWorkflowAdvance() {
        if (workflowTimer || prefersReducedMotion()) {
            return;
        }

        const duration = vm.workflowStep === 2 ? 12200 : 5200;
        workflowTimer = $timeout(function () {
            workflowTimer = null;
            advanceWorkflow();
            scheduleWorkflowAdvance();
        }, duration);
    }

    function setWorkflowStep(step) {
        pauseWorkflow();
        activateWorkflowStep(step);
    }

    function activateWorkflowStep(step) {
        vm.workflowStep = step;
        if (step === 2) {
            startWritingAnimation(true);
        } else if (writingTimer) {
            $interval.cancel(writingTimer);
            writingTimer = null;
        }

        if (step === 3) {
            startRankingAnimation(true);
        } else if (rankingTimer) {
            $interval.cancel(rankingTimer);
            rankingTimer = null;
        }
    }

    function prefersReducedMotion() {
        return Boolean(
            window.matchMedia
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches
        );
    }

    function initializeWritingAnimation() {
        writingSegments = [
            {field: 'title', text: $translate.instant('wa.landing.workflow.writing.editor.title')},
            {field: 'paragraph1', text: $translate.instant('wa.landing.workflow.writing.editor.paragraph1')},
            {field: 'heading', text: $translate.instant('wa.landing.workflow.writing.editor.heading')},
            {field: 'paragraph2', text: $translate.instant('wa.landing.workflow.writing.editor.paragraph2')},
            {type: 'images'},
            {field: 'heading2', text: $translate.instant('wa.landing.workflow.writing.editor.heading2')},
            {field: 'paragraph3', text: $translate.instant('wa.landing.workflow.writing.editor.paragraph3')},
        ];
        vm.writingPreview = {
            title: '',
            paragraph1: '',
            heading: '',
            paragraph2: '',
            heading2: '',
            paragraph3: '',
            showCover: true,
            showImages: false,
        };
        vm.writingBlock = 0;
        vm.writingScore = 24;
        vm.writingReasoning = $translate.instant('wa.landing.workflow.writing.reasoning.preparing');
        vm.writingSuggestions = createWritingSuggestions();
        writingSegmentIndex = 0;
        writingTypedCharacters = 0;
        lastWritingScrollAt = 0;
        writingTotalCharacters = writingSegments
            .filter(segment => segment.text)
            .reduce((total, segment) => total + segment.text.length, 0);
        writingComplete = false;
    }

    function startWritingAnimation(reset) {
        if (reset) {
            initializeWritingAnimation();
        }
        if (prefersReducedMotion()) {
            showFinalWritingState();
            return;
        }
        if (writingTimer || writingComplete) {
            return;
        }
        writingTimer = $interval(typeNextWritingChunk, 18);
    }

    function typeNextWritingChunk() {
        if (writingSegmentIndex >= writingSegments.length) {
            finishWritingAnimation();
            return;
        }

        const segment = writingSegments[writingSegmentIndex];
        vm.writingBlock = writingSegmentIndex;
        updateWritingReasoning();

        if (segment.type === 'images') {
            vm.writingPreview.showImages = true;
            writingSegmentIndex += 1;
            updateWritingProgress();
            scrollToWritingCursor();
            return;
        }

        const currentLength = vm.writingPreview[segment.field].length;
        const nextLength = Math.min(currentLength + 1, segment.text.length);
        vm.writingPreview[segment.field] = segment.text.slice(0, nextLength);
        writingTypedCharacters += nextLength - currentLength;
        updateWritingProgress();
        const now = Date.now();
        if (now - lastWritingScrollAt >= 110 || nextLength >= segment.text.length) {
            lastWritingScrollAt = now;
            scrollToWritingCursor();
        }

        if (nextLength >= segment.text.length) {
            writingSegmentIndex += 1;
        }
    }

    function updateWritingProgress() {
        const progress = writingTotalCharacters
            ? Math.min(1, writingTypedCharacters / writingTotalCharacters)
            : 0;

        vm.writingScore = Math.min(92, Math.round(24 + (68 * progress)));
        vm.writingSuggestions.forEach(function (suggestion) {
            suggestion.resolved = suggestion.id === 'images'
                ? vm.writingPreview.showImages
                : progress >= suggestion.threshold;
        });
    }

    function scrollToWritingCursor() {
        $timeout(function () {
            const editor = document.getElementById('wa-writing-preview');
            const cursor = editor && editor.querySelector('.wa-landing__editor-inline-caret');
            if (!editor || !cursor) {
                return;
            }

            const editorRect = editor.getBoundingClientRect();
            const cursorRect = cursor.getBoundingClientRect();
            const overflow = cursorRect.bottom - editorRect.bottom + 22;
            if (overflow > 0) {
                editor.scrollTop += overflow;
            }
        }, 0, false);
    }

    function finishWritingAnimation() {
        showFinalWritingState();
        if (writingTimer) {
            $interval.cancel(writingTimer);
            writingTimer = null;
        }
    }

    function showFinalWritingState() {
        writingSegments.forEach(function (segment) {
            if (segment.field) {
                vm.writingPreview[segment.field] = segment.text;
            }
        });
        vm.writingPreview.showImages = true;
        vm.writingPreview.showCover = true;
        vm.writingBlock = writingSegments.length;
        vm.writingScore = 92;
        vm.writingReasoning = $translate.instant('wa.landing.workflow.writing.reasoning.complete');
        vm.writingSuggestions.forEach(function (suggestion) {
            suggestion.resolved = true;
        });
        writingComplete = true;
        scrollToWritingCursor();
    }

    function updateWritingReasoning() {
        let key = 'reasoning.seo';
        if (vm.writingBlock <= 1) {
            key = 'reasoning.structure';
        } else if (vm.writingBlock <= 3) {
            key = 'reasoning.content';
        } else if (vm.writingBlock === 4) {
            key = 'reasoning.images';
        }
        vm.writingReasoning = $translate.instant(`wa.landing.workflow.writing.${key}`);
    }

    function startRankingAnimation(reset) {
        if (reset) {
            rankingProgress = 0;
            updateRankingMetrics();
        }
        if (prefersReducedMotion()) {
            rankingProgress = 1;
            updateRankingMetrics();
            return;
        }
        if (rankingTimer || rankingProgress >= 1) {
            return;
        }
        rankingTimer = $interval(function () {
            rankingProgress = Math.min(1, rankingProgress + 0.06);
            updateRankingMetrics();
            if (rankingProgress >= 1) {
                $interval.cancel(rankingTimer);
                rankingTimer = null;
            }
        }, 170);
    }

    function updateRankingMetrics() {
        const visits = Math.round(8400 * rankingProgress);
        vm.rankingVisits = visits >= 1000
            ? `${(visits / 1000).toFixed(1).replace('.', ',')}k`
            : String(visits);
        vm.rankingPosition = `#${Math.max(2, Math.round(10 - (8 * rankingProgress)))}`;
    }

    function createWritingSuggestions() {
        return [
            {id: 'h1', threshold: 0.1, resolved: false, key: 'wa.landing.workflow.writing.suggestion.h1'},
            {id: 'keyword', threshold: 0.22, resolved: false, key: 'wa.landing.workflow.writing.suggestion.keyword'},
            {id: 'headings', threshold: 0.34, resolved: false, key: 'wa.landing.workflow.writing.suggestion.headings'},
            {id: 'images', threshold: 1, resolved: false, key: 'wa.landing.workflow.writing.suggestion.images'},
            {id: 'paragraphs', threshold: 0.56, resolved: false, key: 'wa.landing.workflow.writing.suggestion.paragraphs'},
            {id: 'links', threshold: 0.68, resolved: false, key: 'wa.landing.workflow.writing.suggestion.links'},
            {id: 'intent', threshold: 0.76, resolved: false, key: 'wa.landing.workflow.writing.suggestion.intent'},
            {id: 'aeoAnswer', threshold: 0.85, resolved: false, key: 'wa.landing.workflow.writing.suggestion.aeoAnswer'},
            {id: 'aeoCopy', threshold: 0.93, resolved: false, key: 'wa.landing.workflow.writing.suggestion.aeoCopy'},
        ];
    }

    $scope.$on('$destroy', pauseWorkflow);

    function getArticles() {
        if (!AuthService.isAuthenticated()) {
            vm.articles = [];
            vm.filteredArticles = [];
            vm.isLoading = false;
            return;
        }

        WriterAssistantService.getArticles()
            .then(function (result) {
                const rows = result && result.data ? result.data : [];
                vm.articles = rows.map(decorateArticle);
                updateArticleCounts();
                applyArticleFilters();
            })
            .catch(function () {
                vm.articles = [];
                vm.filteredArticles = [];
                updateArticleCounts();
            })
            .finally(function () {
                vm.isLoading = false;
            });
    }

    function decorateArticle(article) {
        const content = article.content || {};
        const container = document.createElement('div');
        container.innerHTML = content.html || '';

        const heading = container.querySelector('h1');
        const headingText = heading ? heading.textContent.trim() : '';
        if (heading) {
            heading.remove();
        }

        const bodyText = (container.textContent || content.text || '')
            .replace(/\s+/g, ' ')
            .trim();
        const title = headingText
            || article.mainKeyword
            || 'Contenuto senza titolo';
        const words = bodyText ? bodyText.split(/\s+/).length : 0;
        const score = Math.max(0, Math.min(100, Number(article.score) || 0));
        const mode = article.mode === 'WRITE_WITH_AI' ? 'ai' : 'manual';
        const country = (article.country || 'IT').toLowerCase();

        return {
            ...article,
            _title: title,
            _excerpt: bodyText.length > 170 ? `${bodyText.slice(0, 167).trim()}…` : bodyText,
            _wordCount: words,
            _score: score,
            _mode: mode,
            _country: country,
            _searchIndex: `${title} ${article.mainKeyword || ''} ${bodyText}`.toLowerCase(),
        };
    }

    function updateArticleCounts() {
        vm.articleCounts.all = vm.articles.length;
        vm.articleCounts.ai = vm.articles.filter(article => article._mode === 'ai').length;
        vm.articleCounts.manual = vm.articles.filter(article => article._mode === 'manual').length;
    }

    function applyArticleFilters() {
        const query = String(vm.articleSearch || '').trim().toLowerCase();

        vm.filteredArticles = vm.articles.filter(function (article) {
            const matchesMode = vm.articleFilter === 'all' || article._mode === vm.articleFilter;
            const matchesQuery = !query || article._searchIndex.includes(query);
            return matchesMode && matchesQuery;
        });
    }

    function setArticleFilter(filter) {
        vm.articleFilter = filter;
        applyArticleFilters();
    }

    function setArticleViewMode(mode) {
        vm.articleViewMode = mode === 'list' ? 'list' : 'widget';
    }

    function setCreationMode(mode) {
        vm.articleDataSet.mode = mode;
    }

    function isCreationMode(mode) {
        return vm.articleDataSet.mode === mode;
    }

    function hasActiveFilters() {
        return vm.articleFilter !== 'all' || Boolean(String(vm.articleSearch || '').trim());
    }

    function clearArticleFilters() {
        vm.articleSearch = '';
        vm.articleFilter = 'all';
        applyArticleFilters();
    }

    function focusComposer() {
        $timeout(function () {
            const composer = document.getElementById('wa-create-keyword-card');
            const input = document.getElementById('wa-create-keyword');
            if (composer && composer.scrollIntoView) {
                composer.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
            if (input) {
                input.focus();
            }
        });
    }

    function deleteArticle(articleId, event) {
        if (event) {
            event.stopPropagation();
        }

        $mdDialog.show({
            controller: 'WriterAssistantDeleteArticleCtrl',
            templateUrl: 'app/modules/writerassistant/editor/dialog/delete-article/delete-article.html',
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                articleId: articleId,
            },
        }).then(function () {
            vm.articles = vm.articles.filter(article => article.id !== articleId);
            updateArticleCounts();
            applyArticleFilters();
        });
    }

    function createArticle() {
        const keyword = String(vm.articleDataSet.mainKeyword || '').trim();
        if (keyword.length < 3) {
            focusComposer();
            return;
        }

        vm.articleDataSet.mainKeyword = keyword;
        $state.go('app.writerassistant.wizard', vm.articleDataSet);
    }

    function updateLimits() {
        UserService.limits()
            .then(function (response) {
                const limits = response && response.data && response.data.limits
                    ? response.data.limits
                    : [];
                setLimits(limits);
            })
            .catch(function () {
                // Keep the cached limits already shown in the header.
            });
    }

    function hydrateCachedLimits() {
        try {
            const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
            if (Array.isArray(userInfo.limits)) {
                setLimits(userInfo.limits);
            }
        } catch (error) {
            // The live request below remains the source of truth.
        }
    }

    function setLimits(limits) {
        vm.analysisLimit = limits.find(service => service.alias === 'analysis') || {};
        vm.aiCreditsLimit = limits.find(service => service.alias === 'ai-credits') || {};
    }
}

SELandingCtrl.$inject = [
    '$scope',
    'AuthService',
    '$mdMedia',
    '$mdDialog',
    '$state',
    'WriterAssistantService',
    'UserService',
    '$timeout',
    '$interval',
    '$translate',
];

export default SELandingCtrl;
